import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=0487f1ae&"
import script from "./Table.vue?vue&type=script&lang=js&"
export * from "./Table.vue?vue&type=script&lang=js&"
import style0 from "./Table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QTable,QSelect,QInput,QSpinnerPuff,QBtn,QIcon,QPopupProxy,QDate,QBtnToggle,QSpace,QTooltip,QMenu,QList,QItem,QItemSection,QSeparator,QTr,QTh,QTd,QDialog,QCardSection,QInnerLoading,QSpinnerHourglass,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QTable,QSelect,QInput,QSpinnerPuff,QBtn,QIcon,QPopupProxy,QDate,QBtnToggle,QSpace,QTooltip,QMenu,QList,QItem,QItemSection,QSeparator,QTr,QTh,QTd,QDialog,QCardSection,QInnerLoading,QSpinnerHourglass})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
